// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"15793700","364":"c6231189","408":"d8afcd02"}[chunkId] + ".chunk.js";
};